"use client"

import { useEffect, useState } from 'react'
import { getElapsedTime, getLastTime } from '../lib/utils'
import { Display } from '../lib/definitions'

type Props = {
  date: Date
  displayType: Display
}
const RealTime = ({ date, displayType }: Props) => {
  const getTextToDate = displayType === Display.ELAPSED_TIME ? getElapsedTime : getLastTime
  const [text, setText] = useState(getTextToDate(date))

  useEffect(() => {
    const intervalId = setInterval(() => {
      setText(getTextToDate(date))
    }, 1000)

    return () => {
      clearInterval(intervalId)
    }
  }, [date, getTextToDate])

  return (
    <div>
      <p>{text}</p>
    </div>
  )
}

export default RealTime